<template>
  <div>
    <title>券卡激活</title>
    <article class="cardArticle">
      <section class="cardCon">
        <header class="tabHeader">
          <p>
            <router-link :to="{path:'/CardsOut'}" v-if="openStoreDefinition==1">券卡定义激活</router-link>
            <router-link class="isActive" :to="{path:'/CardsActivation'}">券卡激活</router-link>
            <router-link :to="{path:'/CardsPause'}">券卡暂停</router-link>
            <router-link :to="{path:'/CardsReuse'}">券卡恢复</router-link>
            <router-link :to="{path:'/CardsRecover'}" v-if="ElementControls('erjimendian')==1">销售回收</router-link>
            <router-link :to="{path:'/CardMdShop'}"  v-if="ElementControls('erjimendian')==1">门店铺券</router-link>
          </p>
        </header>
        <main class="cardMain">
          <!-- S 券卡验证表单 -->
          <CodeCheck v-if="update" :codeCover="activation" @verifytype="verifyType" :operType="1" :codeType="codeType">
          </CodeCheck>
          <!-- E 券卡验证表单 -->
          <section>
            <el-form :model="basicForm" ref="ruleForm" :rules="rules" label-width="100px">
              <!-- S 基础设置 -->
              <p class="commonTit"><b>基础设置</b></p>
              <section class="basicSet">
                <!-- <el-form-item label="重新定义流向">
                                    <el-switch
                                    v-model="basicForm.bcoverflow">
                                    </el-switch>
                                </el-form-item> -->
                <el-form-item label="券卡流向" class="reFlowCon">
                  <el-button type="primary" size="small" v-if="memberList==''" plain @click="memberopen">选择会员
                  </el-button>
                  <div v-if="memberList!=''" class="memberPop">
                    <ul class="flexBet">
                      <li class="flexUpDownCenter">
                        <div class="memberImg">
                          <img v-if="memberList.hpurl" :src="memberList.hpurl" alt="" />
                          <img v-else src="https://presale.jhtsoft.com/picms/c47519dc61feb.png" alt="">
                        </div>
                        <div class="memberInfo">
                          <strong class="flexUpDownCenter"><span>{{memberList.nickname}}</span><i
                              :class="[{'iconmale':memberList.sex==0,'iconfemale':memberList.sex==1}]"></i></strong>
                          <b class="commonNum">{{memberList.mphone}}</b>
                          <em>{{memberList.mlevelname|| '新手会员'}}</em>
                        </div>
                      </li>
                      <li>
                        <span @click="getShowChoseMem">修改</span>&nbsp;&nbsp;
                        <span class="redColor" @click="deleteMember">删除</span>
                      </li>
                    </ul>
                  </div>
                </el-form-item>
                <template v-if="ElementControls('isShowMdActCardprice')!=2">
                <el-form-item label="券卡售价"
                  v-if="ElementControls('isShowMdActCardprice')==1&&userInfoMd.actpriceismust==1" :key="3"
                  prop="cardsmallprice">
                  <el-input v-model="basicForm.cardsmallprice" @input="prive" maxlength="9"><i slot="prepend">￥</i>
                  </el-input>
                  <p class="quickMsg"><i class="iconbulb"></i>填写后将覆盖原有券卡售价</p>
                </el-form-item>
                <el-form-item label="券卡售价" v-else>
                  <el-input v-model="basicForm.cardsmallprice" @input="prive" maxlength="9"><i slot="prepend">￥</i>
                  </el-input>
                  <p class="quickMsg"><i class="iconbulb"></i>填写后将覆盖原有券卡售价</p>
                </el-form-item>
                </template>
                <el-form-item label="有效期" class="defineRow" v-if="updValdateOfStoreAct==1">
                  <el-date-picker v-model="basicForm.codeDate"
                    :disabled="basicForm.isLongTermEffective||(mdactextendvaliddate==1?true:false)" type="daterange"
                    align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                  <span class="btnRight top0" v-show="mdactextendvaliddate!=1">
                    <el-checkbox v-model="basicForm.isLongTermEffective" label="长期有效"></el-checkbox>
                    <em class="quickMsg"><i class="iconbulb"></i>若不设置，则默认为总部设置的有效期。</em>
                  </span>
                  <span v-show="mdactextendvaliddate==1">
                    <em class="quickMsg"><i class="iconbulb"></i>系统配置已开通自动延长</em>
                  </span>
                </el-form-item>
                <!--<el-form-item label="面单打印备注">
                                    <el-input type="textarea" v-model="basicForm.printmemo" maxlength="20"></el-input>
                                </el-form-item>-->
                <el-form-item label="客服备注" v-if="mdActiveSermemo==1" :key="6" prop="sermemo">
                  <el-input type="textarea" v-model="basicForm.sermemo" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                  <el-input type="textarea" v-model="basicForm.memo" maxlength="100"></el-input>
                </el-form-item>
              </section>
            </el-form>
          </section>
        </main>
        <div class="bottomBtn">
          <el-button type="primary" @click="Submission" :loading="loadingshow">提交</el-button>
          <el-button @click="reload">重置</el-button>
        </div>
      </section>
    </article>
    <!-- S 选择会员 -->
    <MemberChose v-if="update" :needdesensitizequery="1" :isAdd="1" :memberChoseDialogVisible="memberChoseDialogVisible"
      :memberLists="memberList" @selected="members" @closeChild="getCloseMemberCld"></MemberChose>
    <!-- E 选择会员 -->
    <!-- S 新增流向 -->
    <!-- <NewStores @getShowStoremd='getShowStoremd' :flowDialogVisible="flowDialogVisible" :carduse="0"></NewStores> -->
    <!-- E 新增流向 -->
  </div>
</template>
<script>
  import Api from "@/apis/api.js";
  import Vue from 'vue';
  import { mapState, mapActions } from "vuex";
  import { Message, MessageBox } from "element-ui";
  export default {
    name: 'CardsActivation',
    components: {
      NewStores: resolve => require(["@/components/CardsFolder/NewStores.vue"], resolve), //新增门店
      CodeCheck: resolve => require(["@/components/CardsFolder/CodeCheck.vue"], resolve), //验证券码
      MemberChose: resolve => require(["@/components/common/MemberChose.vue"], resolve), //选择会员
    },
    data() {
      return {
        mdactextendvaliddate: 0,
        mdActiveSermemo: 0,
        updValdateOfStoreAct: 0,
        memberList: '', //会员数据
        openStoreDefinition: 0,
        smallpageSize: 30,// 条数
        smallcurrentPage: 1, // 页数
        smallpageTotal: 0,
        userInfoMd: '',
        loadingshow: false,
        update: true,
        verifytype: 0,
        cmpyinfo: '',
        menber: [],
        flowList: [],
        codeType: '0',//券卡类型-礼品券卡
        labelPosition: "right", //labe文字右对齐,
        // 基础设置表单
        basicForm: {
          nameway: '',
          codeDate: '',//有效日期
          cardsmallprice: '',//券卡售价
          printmemo: '',//面单打印备注
          sermemo: '',//客服备注
          memo: '',//备注
          bcoverflow: true,//重新定义流向
          cardflow: "0", //券卡流向，默认为内部流向
          flowcode: '0', // 门店流向编号
          flowname: '门店直发', //门店流向名称
          isLongTermEffective: false,//长期有效
        },
        //选择时间
        pickerOptions: {
        },
        memberChoseDialogVisible: false, //选择会员弹框
        flowDialogVisible: false, //新增流向弹出框
        // 省市区
        addList: [
          {
            value: "js",
            label: "江苏省",
            children: [
              {
                value: "nj",
                label: "南京市",
                children: [
                  {
                    value: "bx",
                    label: "白下区"
                  },
                  {
                    value: "xs",
                    label: "相山区"
                  },
                  {
                    value: "gx",
                    label: "高新区"
                  }
                ]
              },
              {
                value: "sz",
                label: "苏州市",
                children: [
                  {
                    value: "hq",
                    label: "虎丘区"
                  },
                  {
                    value: "wz",
                    label: "吴中区"
                  }
                ]
              }
            ]
          },
          {
            value: "ah",
            label: "安徽省",
            children: [
              {
                value: "hf",
                label: "合肥市",
                children: [
                  {
                    value: "yh",
                    label: "瑶海区"
                  },
                  {
                    value: "bh",
                    label: "滨湖区"
                  }
                ]
              },
              {
                value: "hb",
                label: "淮北市",
                children: [
                  {
                    value: "xs",
                    label: "相山区"
                  },
                  {
                    value: "ls",
                    label: "烈山区"
                  },
                  {
                    value: "yq",
                    label: "埇桥区"
                  }
                ]
              }
            ]
          }
        ],
        rules: {
          cardsmallprice: [
            { required: true, message: '请输入券卡售价', trigger: 'blur' },
            { validator: this.cardsmallprices, trigger: 'blur' }
          ],
          sermemo: [
            { required: true, message: '请输入客服备注', trigger: 'blur' }
          ],
        },
        activation: 'activation',// 券卡验证组件传值
      }
    },
    watch: {
      "basicForm.isLongTermEffective": function (val) {
        if (val) {
          this.basicForm.codeDate = '';
        }
      },
      // 券卡流向切换
      "basicForm.cardflow": function (val) {
        if (val == 0) {
          this.basicForm.flowcode = '0';
          this.basicForm.flowname = "门店直发";
          this.memberList = '';
        } else {
          if (this.memberList == '') {
            this.memberChoseDialogVisible = true;
          }
          this.basicForm.flowcode = '';
          this.basicForm.flowname = "";
        }
      },
    },
    // ==================================== 计算属性 ====================================
    computed: {
      ...mapState({
        bdis: ({ common }) => common.bdis,
      })
    },
    // ============================================== 方法 ==============================================
    methods: {
      deleteMember() {
        this.basicForm.flowcode = '0';
        this.basicForm.flowname = "门店直发";
        this.memberList = '';
      },
      memberopen() {
        this.memberChoseDialogVisible = true;
      },
      prive() {
        this.basicForm.cardsmallprice = this.amountChech(this.basicForm.cardsmallprice);
      },
      Submission() {
        this.loadingshow = true;
        let param = {
          verifytype: this.verifytype,
          cardsmallprice: this.basicForm.cardsmallprice,
          flowcode: this.basicForm.flowcode ? this.basicForm.flowcode : '0',
          flowname: this.basicForm.flowname == 0 ? '门店直发' : this.basicForm.flowname,
          memo: this.basicForm.memo,
          sermemo: this.basicForm.sermemo,
          isLongTermEffective: this.basicForm.isLongTermEffective ? 1 : 0,
          startvaldate: this.basicForm.codeDate ? this.dateTime(this.basicForm.codeDate[0]) : '', //起始有效期
          endvaldate: this.basicForm.codeDate ? this.dateTime(this.basicForm.codeDate[1]) : '', //结束有效期
        }
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            if (this.basicForm.cardsmallprice != '') {
              let reg = (/^(([1-9]\d*)|\d)(\.\d{1,2})?$/);
              this.basicForm.cardsmallprice = this.amountChech(this.basicForm.cardsmallprice);
              if (!reg.test(this.basicForm.cardsmallprice)) {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  message: '输入正确的金额！'
                });
                this.basicForm.cardsmallprice = '';
                this.loadingshow = false;
                return
              } else if (this.amountChech(this.basicForm.cardsmallprice) && this.basicForm.cardsmallprice != '0.' && this.basicForm.cardsmallprice != '0.00' && this.basicForm.cardsmallprice != '0.0') {
                this.basicForm.cardsmallprice = this.amountChech(this.basicForm.cardsmallprice);
              } else {
                this.$message({
                  dangerouslyUseHTMLString: true,
                  message: '输入正确的金额！'
                });
                this.basicForm.cardsmallprice = '';
                this.loadingshow = false;
                return
              }
            }
            Api.CODEINFOACTOPER(param).then(res => {
              if (res.data.status == "200") {
                this.reload();
                this.loadingshow = false;
                MessageBox.confirm(res.data.message, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true,
                  type: 'success'
                }).then(() => { }).catch(() => { });
              } else {
                if (res.data.status == "201") {
                  this.reload();
                }
                this.loadingshow = false;
                MessageBox.confirm(res.data.message, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  dangerouslyUseHTMLString: true,
                  type: 'warning'
                }).then(() => { }).catch(() => { });
              }
            })
          } else {
            this.loadingshow = false;
            return false;
          }
        });


      },
      cardsmallprices(rule, value, callback) {
        console.log(value, '22222222')
        if (this.amountChech(value) && value != '0.' && value != '0.00' && value != '0.0') {
          callback();
          this.basicForm.cardsmallprice = this.amountChech(value);
        } else {
          callback(new Error('输入正确的金额！'));
          this.basicForm.cardsmallprice = '';
        }
      },
      storeRptPwds(rule, value, callback) {
        if (value != this.flowForm.storePwd) {
          callback(new Error('密码不一致！'));
        } else {
          callback();
        }
      },
      // 验证类型
      verifyType(type) {
        this.verifytype = type
      },
      // 打开选择会员弹窗
      getShowChoseMem() {
        this.memberChoseDialogVisible = true;
      },
      // 关闭选择会员弹窗
      getCloseMemberCld() {
        if (this.memberList == '') {
          this.basicForm.cardflow = '0';
        }
        this.memberChoseDialogVisible = false;
      },
      // 打开、关闭新增门店弹窗
      getShowStoremd(val) {
        this.flowDialogVisible = val;
      },
      getShowStore(val) {
        this.flowDialogVisible = val;
      },
      // 会员信息
      members(val) {
        this.memberList = val;
        this.basicForm.flowcode = val.mcode;
        if (val.nickname && val.mphone) {
          this.basicForm.flowname = val.mphone + '-' + val.nickname;
        } else if (val.nickname) {
          this.basicForm.flowname = val.nickname;
        } else {
          this.basicForm.flowname = val.mphone;
        }
      },
      flowcodes(val) {
        this.flowList.some((item, index) => {
          if (val == item.flowcode) {
            this.basicForm.flowname = item.flowname;
            return true;
          }
        })
        if (val == 0) {
          this.basicForm.flowname = '门店直发';
        }
        this.basicForm.flowcode = val;
      },
      // 流向方
      getFlowList() {
        let param = {
          status: 1,
          objtype: 0
        }
        Api.GET_FLOWLIST(param).then(res => {
          if (res.data.status == "200") {
            this.flowList = res.data.data;
          } else {
            this.flowList = [];
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      smallhandleCurrentChange(val) {
        this.smallcurrentPage = val;
        this.getMemberList()
      },
      // 会员
      getMemberList() {
        //   let param ={
        //       keyword:this.basicForm.nameway,
        //       bsharemember:this.userInfoMd.bsharemember,
        //       pageparam:{
        //             pagesize: this.smallpageSize, //每页条数
        //             currentpage: this.smallcurrentPage, //当前页数
        //       }
        //   }
        //  Api.GET_MEMBERLIST(param).then(res =>{
        //    if(res.data.status=="200"){
        //      console.log('xyj')
        //      this.menber = res.data.data;
        //      this.smallpageTotal = res.data.pagebean.totalnum;
        //    }else{
        //      this.menber = [];
        //      this.smallpageTotal = 0;
        //    }
        //  })
      },
      reload() {
        this.resetForm('ruleForm');
        this.memberList = ''; //会员数据
        this.basicForm = {
          codeDate: '',//有效日期
          cardsmallprice: '',//券卡售价
          printmemo: '',//面单打印备注
          sermemo: '',//客服备注
          memo: '',//备注
          bcoverflow: true,//重新定义流向
          cardflow: "0", //券卡流向，默认为内部流向
          flowcode: '0', // 门店流向编号
          flowname: '门店直发', //门店流向名称
          isLongTermEffective: false,
        },
          // 移除组件
          this.update = false
        // 在组件移除后，重新渲染组件
        // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
        this.$nextTick(() => {
          this.update = true
        })
        this.tetsd()
      },
      inputBlur() {
        if (this.menber.length <= 0) {
          this.basicForm.flowname = '门店直发';
          this.basicForm.flowcode = '0';
        }
      },
      closeFlowName() {
        this.basicForm.nameway = '';
        this.smallcurrentPage = 1;
        console.log(this.basicForm.flowname, 'this.basicForm.flowname')
        this.getMemberList();
      },
      inputChange(val) {
        console.log(val)
        this.basicForm.nameway = val;
        this.smallcurrentPage = 1;
        this.getMemberList();
      },
      tetsd(){
        if (this.updValdateOfStoreAct == 1) {
        let mdactextend = this.ElementControls('mdactextendvaliddate')
        if (mdactextend.includes('@')) {
          let lists = mdactextend.split('@')
          if (lists[0] == 1) {
            this.mdactextendvaliddate = 1
          }
        }
        if (this.mdactextendvaliddate == 1) {
          Api.GET_MDACTEXTENDVALIDDATE().then(res => {
            if (res.data.status == "200") {
              let liet = res.data.data
              let startdate = liet.startdate
              let enddate = liet.enddate
              this.basicForm.codeDate = [startdate, enddate]
            }
          })
        }
      }
      }
    },
    mounted() {
      this.openStoreDefinition = this.ElementControls('openStoreDefinition');
      this.updValdateOfStoreAct = this.ElementControls('updValdateOfStoreAct');
      this.tetsd()
      this.mdActiveSermemo = this.ElementControls('mdActiveSermemo');
      if (localStorage.getItem('userInfoMd') && localStorage.getItem('userInfoMd') != 'null') {
        this.userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'))
      }
      if (localStorage.getItem("cmpyinfo")) {
        this.cmpyinfo = JSON.parse(localStorage.getItem("cmpyinfo"));
      }
      this.getFlowList();
    },
  }
</script>
<style scoped>
  .cardArticle {
    padding: 20px;
  }

  .cardMain>>>.el-input__inner {
    color: #666;
  }

  .cardCon {
    position: relative;
    padding: 84px 20px 85px 0;
    height: calc(100% - 169px);
  }

  @media (max-width: 1310px) {
    .cardCon header a {
      padding: 0 16px;
    }
  }

  .basicSet {
    padding: 20px;
  }

  /* .basicSet .el-input,
.basicSet .el-range-editor.el-input__inner,
.basicSet .el-textarea{
    width:300px;
} */
  .basicSet>>>.el-form-item:not(.allWidth) .el-form-item__content {
    width: 65%;
    min-width: 200px;
    max-width: 340px;
    white-space: nowrap;
  }

  .basicSet>>>.el-form-item__content .el-select,
  .basicSet>>>.el-form-item__content .el-input,
  .basicSet>>>.el-range-editor.el-input__inner,
  .basicSet>>>.el-textarea {
    width: 100%;
  }

  .addStore .el-checkbox-group {
    display: inline-block;
  }

  .addStore em {
    margin: 0 5px;
    font-weight: bold;
    cursor: pointer;
  }

  .defineRow {
    position: relative;
  }

  .defineRow .btnRight {
    position: absolute;
    left: calc(100% + 10px);
    top: 6px;
    display: inline-block;
    white-space: nowrap;
    cursor: pointer;
    color: #666;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .btnRight.top0 {
    top: 0 !important;
  }

  .memberPop {
    position: relative;
    background: #fff;
    border-radius: 4px;
    -o-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    -ms-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    -webkit-box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  }

  /* .memberPop::before {
  display: inline-block;
  content: "";
  position: absolute;
  background: #fff;
  -o-transform: rotate(-135deg);
  -ms-transform: rotate(-135deg);
  -moz-transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
  -o-box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  -ms-box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.1);
  width: 13px;
  height: 13px;
} */
  .memberPop {
    margin-bottom: 5px;
    padding: 10px 20px 15px 10px;
    line-height: 1.5;
  }

  .memberPop::before {
    left: 45%;
    margin: auto;
    top: -6.5px;
  }

  .memberPop .memberImg {
    width: 60px;
    height: 60px;
    position: relative;
    border: solid 1px #ebeef5;
    box-sizing: border-box;
    border-radius: 100%;
    overflow: hidden;
  }

  .memberPop .memberImg img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }

  .memberPop .memberInfo {
    margin-left: 10px;
  }

  .memberPop .memberInfo strong {
    color: #666;
    font-weight: bold;
  }

  .memberPop .memberInfo strong span {
    max-width: 140px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .memberPop .memberInfo strong i {
    color: var(--main-color);
    font-size: 18px;
    margin-left: 5px;
    vertical-align: text-bottom;
  }

  .memberPop .memberInfo b {
    color: #999;
    display: block;
    line-height: 20px;
  }

  .memberPop .memberInfo em {
    width: 60px;
    height: 20px;
    border-radius: 10px;
    background: #f2962c;
    color: #fff;
    font-size: 12px;
    padding: 2px 6px;
  }

  .memberPop li:last-child {
    color: var(--main-color);
    cursor: pointer;
  }

  .quickMsg {
    display: inline-block;
    color: #999;
    font-size: 12px;
    line-height: 40px;
    margin-left: 20px;
  }

  .quickMsg i {
    color: #F2962C;
    font-size: 16px;
    margin-right: 5px;
  }

  .giftBtn {
    margin-left: 20px;
    padding: 7px 11px;
    font-size: 12px;
    color: var(--main-color);
    border: 1px solid var(--main-color);
  }

  /* 预售品牌下拉样式*/
  .w340 .el-select,
  .w340 .el-input,
  .w340 .el-range-editor.el-input__inner {
    width: 100%;
    min-width: 200px;
    max-width: 340px;
  }

  .el-scrollbar__view {
    position: relative;
    padding-bottom: 40px;
  }

  .el-scrollbar__view>>>.el-pagination {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/CardsFolder/CardsGift/CardManage/CardsActivation.vue